import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeployComponent } from './components/deploy.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DeployStepperItemComponent } from './components/deploy-stepper-item.component';
import { EffectsModule } from '@ngrx/effects';
import { DeployAlertComponent } from './components/deploy-alert.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from '../shared/shared.module';
import { Map3UiModule } from '@trim-web-apps/map3-ui';
import { DeployEffects } from './+state/deploy.effects';
import { ValidationErrorsComponent } from './components/validation-errors.component';

@NgModule({
  declarations: [
    DeployComponent,
    DeployStepperItemComponent,
    DeployAlertComponent,
    ValidationErrorsComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    // StoreModule.forFeature(ADMIN_DEPLOY_FEATURE_KEY, reducer),
    EffectsModule.forFeature([DeployEffects]),
    ScrollingModule,
    SharedModule,
    Map3UiModule,
  ],
  exports: [DeployAlertComponent],
})
export class DeployModule {}
